import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toastr from "toastr";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import CampoPreguntaEncuesta from "../../../components/Clima/Encuesta/pregunta";
import { getSurvey } from "../../../redux/climalaboral/Encuestas/actions";
import {
  getCuestionariosById,
  saveCuestionariosAnswers,
} from "../../../redux/climalaboral/cuestionario/action";

const sort_lists = (key, list, inverse) =>
  inverse
    ? [...list].sort((b, a) =>
        b[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : 1
      )
    : [...list].sort((a, b) =>
        a[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : -1
      );

const Encuesta = (props) => {
  const [validated, setValidated] = useState(false);

  const [preguntasT, setPreguntasT] = useState([]);
  const [respuestas, setRespuestas] = useState([]);

  const [respuestasF, setRespuestasF] = useState([]);

  const { surveyLoading, survey } = useSelector((store) => store.cuestionario);

  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const encuestaValue = useSelector((store) => store.survey.survey);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setValidated(false);
  }, []);

  useEffect(() => {
    if (props.match.params.idCuestionario) {
      dispatch(
        getCuestionariosById(
          parseInt(props.match.params.idCuestionario),
          setRespuestasF,
          parseInt(props.match.params.idEncuesta)
        )
      );
    }
  }, [props.match.params.idCuestionario]);

  useEffect(() => {
    if (props.match.params.idEncuesta && userId && userType) {
      dispatch(
        getSurvey(
          parseInt(props.match.params.idEncuesta),
          userId,
          userType,
          history
        )
      );
    }
  }, [dispatch, userId, userType, props.match.params.idEncuesta]);

  useEffect(() => {
    if (survey && survey.list_preguntas.length > 0) {
      survey.list_preguntas.sort((a, b) => {
        if (a.posicion !== null && b.posicion !== null) {
          if (parseInt(a.posicion) === parseInt(b.posicion) && a.id > b.id) {
            return 1;
          }

          if (parseInt(a.posicion) === parseInt(b.posicion) && a.id < b.id) {
            return -1;
          }

          if (parseInt(a.posicion) < parseInt(b.posicion)) {
            return -1;
          }
        }
        if (a.id > b.id) {
          return 1;
        }
        if (a.id < b.id) {
          return -1;
        }
      });
      setPreguntasT(
        survey.list_preguntas.sort((a, b) => {
          if (a.posicion !== null && b.posicion !== null) {
            if (parseInt(a.posicion) === parseInt(b.posicion) && a.id > b.id) {
              return 1;
            }

            if (parseInt(a.posicion) === parseInt(b.posicion) && a.id < b.id) {
              return -1;
            }

            if (parseInt(a.posicion) < parseInt(b.posicion)) {
              return -1;
            }
          }
          if (a.id > b.id) {
            return 1;
          }
          if (a.id < b.id) {
            return -1;
          }
        })
      );
    } else {
      setPreguntasT([]);
    }
  }, [survey]);

  useEffect(() => {
    if (
      encuestaValue &&
      encuestaValue.campaña_list &&
      encuestaValue.campaña_list.activa &&
      encuestaValue.fecha_llenado !== null &&
      userId &&
      userType
    ) {
      // history.goBack ();
      toastr.info("Usted ya lleno esta encuesta");
      history.push(`/detalle-empleado/${userId}/${userType}`);
    }
    if (
      encuestaValue &&
      encuestaValue.campaña_list &&
      !encuestaValue.campaña_list.activa &&
      userId &&
      userType
    ) {
      toastr.info("La encuesta ya no esta disponible");
      history.push(`/detalle-empleado/${userId}/${userType}`);
    }
  }, [encuestaValue, userId, userType]);

  const onSubmit = (e) => {
    if (window.confirm("Quiere guardar los cambios y salir?")) {
      e.preventDefault();

      const form = e.currentTarget;
      if (
        form.checkValidity() === false ||
        preguntasT.length < respuestas.length
      ) {
        toastr.error(
          "Asegurese de que todos los campos solicitados vayan llenos"
        );
        setValidated(true);
        return;
      }
      dispatch(
        saveCuestionariosAnswers(respuestasF, history, userId, userType)
      );
    }
  };

  const CerradoPrueba = () => {
    if (
      window.confirm(
        "Esta seguro que quiere salir, los cambios realizados se borraran?"
      )
    ) {
      history.push(`/detalle-empleado/${userId}/${userType}`);
    }
  };

  return (
    <>
      <Form onSubmit={onSubmit} noValidate validated={validated}>
        <div>
          <div className="estiloFondo2 pl-md-4 pr-md-3 pl-3 pr-3 pr-1 pt-3 pb-3 shadow d-flex flex-wrap justify-content-between align-items-center">
            <h6
              className="encuestaClimaLogo m-0 font-weight-bold text-uppercase d-flex flex-wrap justify-content-between align-items-center"
              onClick={CerradoPrueba}
            >
              <i className="material-icons mr-1">cloud</i>
              Clima Laboral
            </h6>
            <div>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Row className="flex-wrap justify-content-center align-items-center">
                    <Dropdown size="sm">
                      <Dropdown.Toggle
                        as={ButtonGroup}
                        className="btn btnDropdown-clima mr-3 flex-wrap justify-content-center align-items-center"
                      >
                        <i className="material-icons">more_vert</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          className="d-flex justify-content-center align-items-center px-4"
                          onClick={CerradoPrueba}
                        >
                          {/* <ButtonGroup>
                          <Button
                            variant="light"
                            size="sm"
                            className="btn rounded-pill d-flex justify-content-center align-items-center"
                            onClick={CerradoPrueba}
                          > */}
                          <i className="material-icons">arrow_back_ios</i>
                          <Col sm="12" md="12" lg="12" xl="12">
                            Salir
                          </Col>
                          {/* </Button>
                        </ButtonGroup> */}
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="d-flex justify-content-center align-items-center px-4"
                          as="button"
                          type="submit"
                        >
                          {/* <ButtonGroup>
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-pill d-flex justify-content-center align-items-center"
                            onClick={onSubmit}
                          > */}
                          <i className="material-icons">send</i>
                          <Col sm="12" md="12" lg="12" xl="12">
                            Enviar
                          </Col>
                          {/* </Button>
                        </ButtonGroup> */}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="custom-wrapper-clima">
          <Container fluid>
            {surveyLoading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <>
                {survey && (
                  // <Container fluid>
                  <div
                    className="
                      flex-wrap
                      justify-content-center
                      align-items-center
                      p-3
                      mb-5
                      "
                    // bg-white
                  >
                    <Row>
                      <Col
                        xs="10"
                        sm="10"
                        md="8"
                        lg="8"
                        xl="8"
                        style={{ margin: "auto" }}
                      >
                        <Row>
                          <Col md="12" className="ml-auto mr-auto">
                            <Form.Group
                              className="shadow-sm mb-5 rounded"
                              style={{ border: "0.1px solid #ced4da" }}
                            >
                              <div className="estiloFondo">
                                <div className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center">
                                  <Button
                                    size="sm"
                                    className="btn rounded-circle"
                                    disabled
                                  >
                                    <i
                                      className="material-icons"
                                      style={{ transform: "rotate(90deg)" }}
                                    >
                                      drag_indicator
                                    </i>
                                  </Button>
                                </div>
                                {/* <div className="px-2">
                                  <hr className="mt-0" />
                                </div> */}
                              </div>
                              <div className="p-3">
                                <Row>
                                  <Form.Group as={Col} className="mb-3">
                                    <Col
                                      className="p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                                      style={{
                                        borderBottom: "0.1px solid #ced4da",
                                      }}
                                      sm="12"
                                      md="12"
                                      lg="12"
                                      xl="12"
                                    >
                                      <h6 className="m-0">
                                        {survey ? survey.nombre : null}
                                      </h6>
                                    </Col>
                                  </Form.Group>
                                </Row>
                                <Row>
                                  <Form.Group as={Col} className="mb-3">
                                    <Col
                                      className="p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                                      style={{
                                        borderBottom: "0.1px solid #ced4da",
                                      }}
                                      sm="12"
                                      md="12"
                                      lg="12"
                                      xl="12"
                                    >
                                      <h6 className="m-0">
                                        {survey ? survey.descripcion : null}
                                      </h6>
                                    </Col>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="ml-auto mr-auto">
                          <Col md="12">
                            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="font-weight-bold text-uppercase">
                                Preguntas
                              </h6>
                            </div>
                            <div className="px-2">
                              <hr />
                            </div>
                          </Col>
                        </Row>
                        {survey.list_preguntas.length === 0 ? (
                          <Alert className="my-4" variant="info">
                            Aún no hay preguntas registradas, consulte al
                            administrador para mas información.
                          </Alert>
                        ) : (
                          <>
                            <Row>
                              <Col md="12" className="ml-auto mr-auto">
                                {sort_lists(
                                  "posicion",
                                  survey.list_preguntas
                                ).map((item, index) => (
                                  <div key={item.id}>
                                    <CampoPreguntaEncuesta
                                      idEncuesta={props.match.params.idEncuesta}
                                      pregunta={item}
                                      index={index}
                                      respuestasF={respuestasF}
                                      setRespuestasF={setRespuestasF}
                                    />
                                  </div>
                                ))}
                              </Col>
                            </Row>
                          </>
                        )}
                        <Col className="d-flex flex-wrap justify-content-end align-items-center">
                          <Button
                            size="sm"
                            type="submit"
                            className="btn btnGuardar-clima ml-1 mr-1 rounded-pill"
                            style={{ backgroundColor: "#141E30" }}
                          >
                            Enviar
                          </Button>
                        </Col>
                      </Col>
                    </Row>
                  </div>
                  //</Container>
                )}
              </>
            )}
          </Container>
        </div>
      </Form>
    </>
  );
};

export default Encuesta;
